
export const RevenueReconciliationReportConstant = {
    Table: {
        REPORT_TYPE: "Report Type",
        PRINTER: "Printer",
        CUT_OFF_DATE_FROM: "Cut Off Date (From)",
        CUT_0FF_DATE_TO: "Cut Off Date (To)",
        CUT_OFF_TIME_FROM: "Cut Off Time (From)",
        CUT_0FF_TIME_TO: "Cut Off Time (To)",
        CUT_OFF_DATE_2ND_FROM: "2ND Cut Off Date (From)",
        CUT_0FF_DATE_2ND_TO: "2ND Cut Off Date (To)",
        CUT_OFF_TIME_2ND_FROM: "2ND Cut Off Time (From)",
        CUT_0FF_TIME_2ND_TO: "2ND Cut Off Time (To)",
        CURRRENCY: "Currency",
        CASHIER_ID: "Cashier Id",
        OPS_DATE_FROM: "Ops Date (From)",
        OPS_DATE_TO: "Ops Date (To)",
        OPS_TIME_FROM: "Ops Date Time(From)",
        OPS_TIME_TO: "Ops Date Time(To)",
        DOC_DATE: "Doc Date",
        DOC_DATE_TIME: "Doc Date(Time)",
        SUB_TYPE: "Sub Type",
    },
    Title: {
        TITLE: "Revenue And Reconciliation",
    },
}
